/** EMP-WS-UI-001 — section tabs with icons + animated active state (testids ws-tab-<id> preserved). */
import React from 'react';
import { Home, User, Briefcase, Contact, Phone, ShieldCheck, Landmark, History, Hourglass } from 'lucide-react';

export const TAB_META = {
  overview: { label: 'Overview', icon: Home },
  basic: { label: 'Basic', icon: User },
  employment: { label: 'Employment', icon: Briefcase },
  personal: { label: 'Personal', icon: Contact },
  contact: { label: 'Contact', icon: Phone },
  statutory: { label: 'Statutory', icon: ShieldCheck },
  banking: { label: 'Banking', icon: Landmark },
  probation: { label: 'Probation', icon: Hourglass },
  activity: { label: 'Activity', icon: History },
};

export const WorkspaceTabs = ({ tabs, active, onChange }) => (
  <nav className="lv-card an-rise px-2 py-1.5 flex gap-1 overflow-x-auto ews-tabs" style={{ animationDelay: '60ms' }} aria-label="Employee sections" data-testid="ws-tabs">
    {tabs.map(t => {
      const m = TAB_META[t] || { label: t, icon: User }; const Icon = m.icon; const on = active === t;
      return (
        <button key={t} type="button" onClick={() => onChange(t)} data-testid={`ws-tab-${t}`} aria-current={on ? 'page' : undefined}
          className={`ews-tab relative flex items-center gap-2 rounded-lg px-3.5 py-2 text-[13.5px] font-medium whitespace-nowrap ${on ? 'text-violet-700 bg-violet-50/70' : 'text-slate-500 hover:text-slate-800 hover:bg-slate-50'}`}>
          <Icon className={`h-4 w-4 ${on ? 'text-violet-600' : 'text-slate-400'}`} />{m.label}
          {on && <span className="ews-tab-ink absolute left-3 right-3 -bottom-[7px] h-0.5 rounded-full bg-violet-600" />}
        </button>
      );
    })}
  </nav>
);
